<div class="documentation-container">
  <div class="sidebar">
    <h3 class="sidebar-title">Documentation</h3>
    <nav class="sidebar-nav">
      <ul class="nav-list">
        <li class="nav-item">
          <button
            class="nav-link"
            [class.active]="selectedSection === 'quotes'"
            (click)="selectSection('quotes')">
            Quotes
          </button>
        </li>
        <li class="nav-item">
          <button
            class="nav-link"
            [class.active]="selectedSection === 'comparison'"
            (click)="selectSection('comparison')">
            Comparison
          </button>
        </li>
      </ul>
    </nav>
  </div>

  <div class="main-content">
    <app-comparison-instructions *ngIf="selectedSection === 'comparison'"></app-comparison-instructions>
    <app-quotes-instructions *ngIf="selectedSection === 'quotes'"></app-quotes-instructions>
  </div>
</div>

<!-- Scroll to Top Button -->
<button
  class="scroll-to-top"
  *ngIf="showScrollToTop"
  (click)="scrollToTop()"
  aria-label="Scroll to top"
>
  <img src="assets/img/mdi_arrow-right-bold.svg" alt="Up arrow" class="arrow-up" />
</button>
